/* eslint-disable react-hooks/rules-of-hooks */
import { AUTH_LOCAL_STORAGE_KEY } from '../app/modules/auth/core/AuthHelpers'

//const AUTH_LOCAL_STORAGE_KEY = window['config'].local_storage_key;
/*
import React from "react";
import {ConfigContext} from "../services/config/ConfigContext";
const {configs, addConfig} = React.useContext(ConfigContext);
*/

const getTest = async () => {
  let test = processGet('test/test2')
  return test
}

const getHeader = () => {
  let header: any = {
    'Content-Type': 'application/json',
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (lsValue) {
    let auth: any = JSON.parse(lsValue)
    if (auth && auth.token) {
      header['Authorization'] = `Bearer ${auth.token}`
    }
  }

  return header
}

const processGet = (path: string, data: any = {}) => {
  return new Promise((resolve, reject) => {
    let base_url = window['config'].base_url
    let url = base_url + path
    let qs = ''
    if (data != null) {
      const qs_array: any = []
      for (const i in data) {
        let dt: string = data[i]
        let idx: string = i + ''
        qs_array.push(`${idx}=${dt}`)
      }
      qs = '?' + qs_array.join('&')
    }
    fetch(url + qs, {
      method: 'GET',
      headers: getHeader(),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === 0 && data.error === 'Not authorized') {
          Logout()
          return
        }
        resolve(data)
      })
      .catch((error) => {
        console.log('Error', error)
        if (error && error.message === 'Not authorized') {
          Logout()
        } else {
          resolve(error)
        }
      })
  })
}

const processPost = (path: string, data: any = {}) => {
  return new Promise((resolve, reject) => {
    let base_url = window['config'].base_url
    let url = base_url + path
    fetch(url, {
      method: 'POST',
      headers: getHeader(),
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === 0 && data.error === 'Not authorized') {
          Logout()
          return
        }
        resolve(data)
      })
      .catch((error) => {
        resolve(error)
        if (error && error.message === 'Not authorized') {
          Logout()
        } else {
          resolve(error)
        }
      })
  })
}

const processPut = (path: string, data: any = {}) => {
  return new Promise((resolve, reject) => {
    let base_url = window['config'].base_url
    let url = base_url + path
    fetch(url, {
      method: 'PUT',
      headers: getHeader(),
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === 0 && data.error === 'Not authorized') {
          Logout()
          return
        }
        resolve(data)
      })
      .catch((error) => {
        resolve(error)
        if (error && error.message === 'Not authorized') {
          Logout()
        } else {
          resolve(error)
        }
      })
  })
}

const processPatch = (path: string, data: any = {}) => {
  return new Promise((resolve, reject) => {
    let base_url = window['config'].base_url
    let url = base_url + path
    fetch(url, {
      method: 'PATCH',
      headers: getHeader(),
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === 0 && data.error === 'Not authorized') {
          Logout()
          return
        }
        resolve(data)
      })
      .catch((error) => {
        resolve(error)
        if (error && error.message === 'Not authorized') {
          Logout()
        } else {
          resolve(error)
        }
      })
  })
}

const processDelete = (path: string) => {
  return new Promise((resolve, reject) => {
    let base_url = window['config'].base_url
    let url = base_url + path
    fetch(url, {
      method: 'DELETE',
      headers: getHeader(),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === 0 && data.error === 'Not authorized') {
          Logout()
          return
        }
        resolve(data)
      })
      .catch((error) => {
        resolve(error)
        if (error && error.message === 'Not authorized') {
          Logout()
        } else {
          resolve(error)
        }
      })
  })
}

const Logout = () => {
  console.log('Logout')
  localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  window.location.reload()
}

export { getTest, processGet, processPost, processPut, processPatch, processDelete }
